import { render, staticRenderFns } from "./TagLegend.vue?vue&type=template&id=64de6048"
import script from "./TagLegend.vue?vue&type=script&lang=js"
export * from "./TagLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports